module.exports = __webpack_public_path__ + "images/assets/26982d8c3960dd6d10c52791f7a7e0ba.svg";